var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("basic-container", [
        _c(
          "div",
          {
            staticStyle: {
              "min-height": "calc(100vh - 180px)",
              background: "#fff",
            },
          },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _vm._l(_vm.boxs, function (item, index) {
                  return [
                    _vm.permissions[item.permissions]
                      ? _c(
                          "el-col",
                          { key: index, attrs: { span: 6 } },
                          [
                            _c("el-card", { staticClass: "box-card" }, [
                              _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      class: item.icon,
                                      staticStyle: {
                                        "font-size": "40px",
                                        color: "#409eff",
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "flex-direction": "column",
                                          "margin-left": "8px",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "#409eff",
                                              "font-weight": "bold",
                                            },
                                          },
                                          [_vm._v(_vm._s(item.name))]
                                        ),
                                        _c("el-divider"),
                                        _c("span", [
                                          _vm._v(_vm._s(item.remark)),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      display: "flex",
                                      "justify-content": "center",
                                      "margin-top": "12px",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { width: "200px" },
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.route(item.url)
                                          },
                                        },
                                      },
                                      [_vm._v("进入")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }